<app-dea-widget-wrapper>
  <div class="d-flex justify-content-between align-items-center gap-4">
    <div class="d-flex align-items-center">
      <div class="fw-semibold">{{userData?.type?.frontend}}</div>
      <div class="ms-3 opacity-50">{{userData?.dea_id}}</div>
    </div>
    <div class="d-flex align-items-center gap-2">
      <ng-content *ngIf="userData?.isStudent()">
        <button class="d-flex align-items-center dea-icon-btn" mat-button aria-label="Contatta Nucleo Familiare"
          title="Contatta Nucleo Familiare" color="secondary" type="button" (click)="contactFamilyByEmail()">
          Contatta Nucleo Familiare <i class="bi bi-envelope-at"></i>
        </button>
        <div class="vr my-auto mx-2" style="height: 32px;"></div>
      </ng-content>
      <button *ngIf="(sectionsState$ | async)?.genPassFunc === true" mat-icon-button class="dea-icon-btn"
        aria-label="Crea credenziali temporanee" title="Crea credenziali temporanee" (click)="createTempCredentials()">
        <mat-icon class="mb-1">key</mat-icon>
      </button>
      <button mat-icon-button aria-label="Modifica Utente" title="Modifica Utente" class="dea-icon-btn"
        routerLink="/modifica-anagrafica/{{userData?.id}}">
        <mat-icon class="mb-1">edit</mat-icon>
      </button>
      <button class="opacity-25" mat-icon-button aria-label="Archivia Utente" title="Archivia Utente" color="warn"
        disabled>
        <mat-icon class="mb-1">archive</mat-icon>
      </button>
    </div>
  </div>
  <br>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
    (selectedTabChange)="tabClick($event)">
    <mat-tab label="Anagrafica">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-user-thumbnail-and-controls [id]="userData?.id"></app-user-thumbnail-and-controls>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="true" [showTags]="true" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-master-data (userDataEmitter)="onUserData($event)"></app-user-master-data>
    </mat-tab>
    <mat-tab label="Ritardi" *ngIf="userData?.type?.backend == 'Student'">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="true" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-justifications-data [startLoading]="tabGroupStatus.ritardi" [userId]="userId" [user]="userData">
      </app-user-justifications-data>
    </mat-tab>
    <mat-tab label="Documenti">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="false" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-documents-data [startLoading]="tabGroupStatus.documenti" [userId]="userId"></app-user-documents-data>
    </mat-tab>
    <mat-tab label="Tech">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="false" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-tech-data [startLoading]="tabGroupStatus.tech" [userId]="userId"></app-user-tech-data>
    </mat-tab>
    <mat-tab label="Moduli">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="false" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-modules-data [startLoading]="tabGroupStatus.moduli" [userId]="userId"></app-user-modules-data>
    </mat-tab>
    <mat-tab label="PCTO" *ngIf="userData?.type?.backend == 'Student'">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="false" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-pcto-data [startLoading]="tabGroupStatus.pcto" [userId]="userId"
        [corso_sicurezza]="userData?.corso_sicurezza">
      </app-user-pcto-data>
    </mat-tab>
    <mat-tab label="Classi" *ngIf="userData?.type?.backend == 'Student' || userData?.type?.backend == 'Teacher'">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="true" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-classes-data [startLoading]="tabGroupStatus.classi" [userId]="userId"></app-user-classes-data>
    </mat-tab>
    <mat-tab label="Quadro Orario" *ngIf="userData?.type?.backend == 'Teacher'">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="true" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-timetable [startLoading]="tabGroupStatus.timetable" [teacherId]="userData?.id"></app-user-timetable>
    </mat-tab>
    <mat-tab label="Licenze">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="true" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-licenses-data [startLoading]="tabGroupStatus.licenze" [userId]="userId"></app-user-licenses-data>
    </mat-tab>
    <mat-tab label="Contratti"
      *ngIf="(sectionsState$ | async)?.agreementsSection === true && (userData?.type?.backend == 'Staff' || userData?.type?.backend == 'Teacher')">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="true" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-agreements-data [startLoading]="tabGroupStatus.accordi"
        [enableTeacherCertificationSection]="userData?.isTeacher() || false"
        [userId]="userId"></app-user-agreements-data>
    </mat-tab>
    <mat-tab label="Provvedimenti" *ngIf="userData?.type?.backend == 'Student'">
      <div class="v-spacer"></div>
      <div class="v-spacer"></div>
      <div class="row m-0 p-0">
        <div class="col-auto m-0 p-0">
          <app-dea-thumbnail-img size="64" id="{{userData?.id}}"></app-dea-thumbnail-img>
        </div>
        <div class="col m-0 p-0 ps-3">
          <app-user-base-data [showFullData]="false" [user]="userData"></app-user-base-data>
        </div>
      </div>
      <app-user-discipline-records-data [startLoading]="tabGroupStatus.provvedimenti" [userId]="userId">
      </app-user-discipline-records-data>
    </mat-tab>
  </mat-tab-group>
</app-dea-widget-wrapper>